module.exports = __webpack_public_path__ + "static/media/Dmitry Poglot.f95f433c.png";